import { render, staticRenderFns } from "./GalleryListLink.vue?vue&type=template&id=69838d21&scoped=true"
import script from "./GalleryListLink.vue?vue&type=script&lang=js"
export * from "./GalleryListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69838d21",
  null
  
)

export default component.exports